var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', _vm._l(_vm.shapedAreas, function (area) {
    return _c('v-chip', {
      key: area._id,
      staticClass: "rounded-0",
      attrs: {
        "small": "",
        "color": area.color,
        "text-color": "white"
      }
    }, [_vm._v(_vm._s(area.name))]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }